<template>
	<div class="invite-container">
		<div class="content">
			<div class="head">
				<div class="close" @click="$router.back()"></div>
				<div class="title"></div>
			</div>
			<VImage :src="require('@/assets/logo-white.png')" class="logo" />
			<div class="tip">亚太礼银用户注册采取审核制，仅对B端用户和保险代理人开放，谢绝C端用户的加入。</div>
			<div class="btn-enter" @click="goLogin">返回登录</div>
		</div>
	</div>
</template>

<script>
import { Image as VImage, Field, Toast } from 'vant'
import { registerDistributor, registerCustomer } from '@/api/login'
import dayjs from "dayjs";

export default {
  components: { VImage },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    goLogin() {
      this.$router.push({
        path: '/login',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.invite-container {
	position: relative;
	height: 100vh;
	width: 100vw;
	background: #c82d26;
	display: flex;
	align-items: center;
	.head {
		display: flex;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		padding: 30px 40px;
		.close {
			display: inline-block;
			width: 30px;
			height: 4px;
			background: #fff;
			border-radius: 4px;
			transform: rotate(45deg);
			&::after {
				content: '';
				display: block;
				width: 30px;
				height: 4px;
				background: #fff;
				border-radius: 4px;
				transform: rotate(-90deg);
			}
		}
		.title {
			flex: 1;
			font-size: 28px;
			line-height: 1;
			height: 28px;
			text-indent: -20px;
		}
	}
	.content {
		width: 100%;
		padding: 0 74px;
		padding-bottom: 160px;
	}
	.logo {
		width: 366px;
		margin-bottom: 152px;
	}
	.phone {
		color: #fff;
		padding-bottom: 40px;
		font-size: 48px;
		line-height: 66px;
		font-weight: bold;
	}
	.btn-invite-code {
		background: #fff;
		color: #c82d26;
		margin-bottom: 40px;
		border-radius: 80px;
		padding: 4px 0;
		overflow: hidden;
		.input {
			font-size: 26px;
			line-height: 26px;
		}
		.input /deep/ input {
			text-align: center;
			color: #c82d26;
			&::placeholder {
				color: #c82d26;
			}
		}
	}
	.btn-enter {
		border-radius: 80px;
		text-align: center;
		font-weight: bold;
		font-size: 26px;
		line-height: 80px;
		color: #fff;
		//border: 1px solid #fff;
		box-sizing: border-box;
    margin-top: 20px;
	}
	.tip {
		font-size: 26px;
		font-weight: 500;
		color: #ffffff;
		line-height: 36px;
		margin-top: 40px;
	}
}
</style>
